const Category =  {
  BUSINESS: 'Business',
  EDUCATION: 'Education',
  ENTERTAINMENT: 'Entertainment',
  FINANCE: 'Finance',
  HEALTHANDFITNESS: 'Health and Fitness',
  LIFESTYLE: 'Lifestyle',
  NEWS: 'News',
  PRODUCTIVITY: 'Productivity',
  REFERENCE: 'Reference',
  SOCIAL: 'Social',
  SPORTS: 'Sports',
  TRAVEL: 'Travel',
  UTILITIES: 'Utilities',
  WEATHER: 'Weather',
  UNCATEGORIZED: 'Uncategorized'
};
export const CATEGORIES_DESCRIPTIONS = {
  [Category.BUSINESS]: 'apps that help users manage or run a business',
  [Category.EDUCATION]: 'apps that are designed to facilitate learning or provide information',
  [Category.ENTERTAINMENT]: 'apps that provide users with enjoyable experiences such as games, movies, or music',
  [Category.FINANCE]: 'apps that help users manage their finances or investments',
  [Category.HEALTHANDFITNESS]: 'apps that track fitness goals or provide medical information',
  [Category.LIFESTYLE]: 'apps that offer users helpful advice on everyday activities or self-improvement',
  [Category.NEWS]: 'apps that provide users with up-to-date news and current events',
  [Category.PRODUCTIVITY]: 'apps that help users accomplish tasks or organize their schedules',
  [Category.REFERENCE]: 'apps that serve as a source of information on a particular topic',
  [Category.SOCIAL]: 'apps that help users connect with others or share information with friends',
  [Category.SPORTS]: 'apps that provide users with sports-related news, scores, or stats',
  [Category.TRAVEL]: 'apps that help users plan travel or find tourist attractions in a specific location',
  [Category.UTILITIES]: 'apps that provide useful tools or utilities to users',
  [Category.WEATHER]: 'apps that provide users with weather forecasts or updates',
};

export const CATEGORIES_COLORS = {
  [Category.BUSINESS]: '#ffd7d4',
  [Category.EDUCATION]: '#ffe2cc',
  [Category.ENTERTAINMENT]: '#e3f2d9',
  [Category.FINANCE]: '#dce4f0',
  [Category.HEALTHANDFITNESS]: '#e4d7f5',
  [Category.LIFESTYLE]: '#d1eeea',
  [Category.NEWS]: '#ffd6d6',
  [Category.PRODUCTIVITY]: '#fff4cc',
  [Category.REFERENCE]: '#ffd9e6',
  [Category.SOCIAL]: '#f9d0e3',
  [Category.SPORTS]: '#cfcfcf',
  [Category.TRAVEL]: '#ffe6cc',
  [Category.UTILITIES]: '#c2d1e5',
  [Category.WEATHER]: '#e6b3b3',
  [Category.UNCATEGORIZED]: '#d9d9d9',
};
